export const LTI_INTEGRATION = "LTI 1.3 (Learning Tools Interoperability)";
export const LEARNING_TOOL = "Learning Tools Interoperability";
export const EXTERNAL_CONTENT_DESCRIPTION = "Moodle, Canvas, etc";
export const LTI_VERSION = "LTI 1.3";
export const LTI = "LTI";
